module.exports = __webpack_public_path__ + "static/media/about5.c282eb7e.jpg";